import { Helmet } from 'react-helmet';
import { getFontLink } from 'styles/fonts';

const HTMLHead = () => {
    const fontBody = getFontLink('urw-form');
    const fontHeading = getFontLink('urw-form');
    // const fontHeading = getFontLink('urw-din-semi-condensed');
    const fontNeutral = getFontLink('Inter');

    return (
        <Helmet key="page-helmet">
            <title>{'Return center'}</title>
            <meta name="title" content={'Return Center'} />
            <meta name="description" content={'Return Center'} />
            <link rel="preconnect" href="https://fonts.gstatic.com" />
            {fontBody}
            {fontHeading}
            {fontNeutral}
        </Helmet>
    );
};

export default HTMLHead;
